import React from 'react'
import { NavItem } from '@/components/molecules/NavItem'
import { Button } from '@/components/molecules/Button'
import './TopNav.css'

import logoImage from '@/assets/lnxdigi_logo_new.png'
import userGroupIcon from '@/assets/user_group_icon.svg'

export interface TopNavProps {
  className?: string
}

export const TopNav: React.FC<TopNavProps> = ({ className = '' }) => {
  const [isScrolled, setIsScrolled] = React.useState(false)

  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true)
      } else {
        setIsScrolled(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const navItems = [
    { label: 'Brands', href: '#brands' },
    { label: 'Services', href: '#services' },
    { label: 'Work', href: '#work' },
    { label: 'Process', href: '#process' },
  ]

  return (
    <nav className={`top-nav ${isScrolled ? 'scrolled' : ''} ${className}`}>
      <div className="top-nav-logo">
        <img src={logoImage} alt="Launchyx Digital" className="top-nav-logo-image" />
      </div>

      <div className="top-nav-items">
        {navItems.map((item) => (
          <NavItem key={item.label} label={item.label} href={item.href} />
        ))}
      </div>

      <div className="top-nav-action">
        <Button
          label="Expert Review"
          iconSrc={userGroupIcon}
          iconAlt="User Group"
          href="https://docs.google.com/forms/d/13rU1q-xrGIBQL86oyoqqr3ps76M2zmmHA4V_RxLUxCM/edit"
          target="_blank"
        />
      </div>
    </nav>
  )
}
